import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { INFRASTRUCTURE } from "@/lib/site-data";
import { ArrowRight } from "lucide-react";

const IMAGES = [
  "https://images.pexels.com/photos/4031654/pexels-photo-4031654.jpeg",
  "https://images.pexels.com/photos/8851556/pexels-photo-8851556.jpeg",
  "https://images.unsplash.com/photo-1755728806854-5f1bb4824174?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxnb2xkJTIwYmFycyUyMGJhbmslMjB2YXVsdHxlbnwwfHx8fDE3ODI0OTQ5Njl8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/20979923/pexels-photo-20979923.jpeg",
  "https://images.pexels.com/photos/30836332/pexels-photo-30836332.jpeg",
  "https://images.pexels.com/photos/6804260/pexels-photo-6804260.jpeg",
  "https://images.pexels.com/photos/8851556/pexels-photo-8851556.jpeg",
  "https://images.pexels.com/photos/4031654/pexels-photo-4031654.jpeg",
];

export default function Infrastructure() {
  const [active, setActive] = useState(0);
  return (
    <section data-testid="infrastructure-section" id="infrastructure" className="py-24 lg:py-32 bg-[#F4F9FC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Infrastructure</div>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
            A facility engineered for <span className="gold-gradient-text font-medium">precision</span>.
          </h2>
        </div>
        <div className="grid lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-5 flex flex-col gap-1.5">
            {INFRASTRUCTURE.map((f, i) => (
              <button
                key={f.title}
                onClick={() => setActive(i)}
                data-testid={`infra-tab-${i}`}
                className={`group text-left px-5 py-4 rounded-md border transition-all flex items-center justify-between ${
                  active === i
                    ? "bg-white border-[#D4AF37] shadow-sm"
                    : "bg-white/50 border-[#E5E5E5] hover:border-[#D4AF37]/60"
                }`}
              >
                <div>
                  <div className="font-heading text-base font-medium text-[#0A0A0A]">{f.title}</div>
                  <div className="text-xs text-[#4B5563] mt-0.5">{f.desc}</div>
                </div>
                <ArrowRight className={`w-4 h-4 transition-all ${active === i ? "text-[#D4AF37] translate-x-1" : "text-[#9ca3af]"}`} strokeWidth={1.5} />
              </button>
            ))}
          </div>
          <div className="lg:col-span-7">
            <div className="relative rounded-2xl overflow-hidden border border-[#E5E5E5] aspect-[4/3] bg-white">
              <AnimatePresence mode="wait">
                <motion.img
                  key={active}
                  src={IMAGES[active % IMAGES.length]}
                  alt={INFRASTRUCTURE[active].title}
                  initial={{ opacity: 0, scale: 1.02 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.6 }}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </AnimatePresence>
              <div className="absolute bottom-4 left-4 right-4 glass-card rounded-xl p-4">
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Facility</div>
                <div className="font-heading text-lg text-[#0A0A0A] mt-0.5">{INFRASTRUCTURE[active].title}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
